import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=39676a34&"
import script from "./UserPage.vue?vue&type=script&lang=ts&"
export * from "./UserPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39676a34')) {
      api.createRecord('39676a34', component.options)
    } else {
      api.reload('39676a34', component.options)
    }
    module.hot.accept("./UserPage.vue?vue&type=template&id=39676a34&", function () {
      api.rerender('39676a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserPage.vue"
export default component.exports